import Manufacturer from '@/plugins/sdk/resources/Asset/Manufacturer'

export default class extends Manufacturer {
  static name = 'assetmanufacturer'
}
